// Makes use of
// https://tempusdominus.github.io/bootstrap-4/

// Sample usage:
// add data-toggle and data-target
// and add the appropriate class to pick the right picker type
// <input id="missionDate" class="form-control date-picker" data-toggle="datetimepicker" data-target="#missionDate" type="text">
$(document).ready(function () {
    var locale = 'us';
    $('.datetime-picker').datetimepicker({
        locale: locale,
    });
    $('.date-picker').datetimepicker({
        locale: locale,
        format: 'L',
    });
    $('.time-picker').datetimepicker({
        locale: locale,
        format: 'LT',
    });
});
